import React from "react";
import "./Chat.css";
import SingularChat from "./SingularChat";

function Chat() {
  return (
    <div className="chat">
      <SingularChat
        name="Mark"
        message="whatss up?"
        timestamp="40 seconds ago"
        profilePic="https://upload.wikimedia.org/wikipedia/commons/3/3f/Mark_Cuban_%26_Doug_Ducey_%2847384954432%29_%28cropped%29.jpg"
      />
      <SingularChat
        name="Ellen"
        message="Hello"
        timestamp="55 minutes ago"
        profilePic="https://upload.wikimedia.org/wikipedia/commons/b/b8/Ellen_DeGeneres_2011.jpg"
      />
      <SingularChat
        name="Kylie"
        message="😅😂"
        timestamp="1 day ago"
        profilePic="https://upload.wikimedia.org/wikipedia/commons/6/65/Kylie_Jenner_in_2021.jpg"
      />
    </div>
  );
}

export default Chat;
